import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('./spring-new-term-plan/Index.vue')
const Address = () => import('./spring-new-term-plan/ActivityAddressConfirm.vue')
// const Record = () => import('../activity/202402/spring-new-term-plan/Record.vue')

export const indexRoute: RouteConfig = {
  path: '/new-term-plan-2025',
  name: 'new_term_plan_2025',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '新学期计划',
    ignoreLogin: true,
  },
}

export const addressRoute: RouteConfig = {
  path: '/new-term-plan-2025-address',
  name: 'new_term_plan_2025_address',
  component: Address,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '领取数字激励盒',
    ignoreLogin: true,
  },
}

// export const recordRoute: RouteConfig = {
//   path: '/new-term-plan-2024-record',
//   name: 'new_term_plan_2024_record',
//   component: Record,
//   props: (route) => ({ ...route.query, ...route.params }),
//   meta: {
//     title: '新学期计划',
//     ignoreLogin: true,
//   },
// }

export default [indexRoute, addressRoute]

export function navigateToNewTermPlan2024(router: VueRouter) {
  router.push({ name: indexRoute.name })
}
